const ValidationHelper = {
  /**
   * Validates a Brazilian CPF (Individual Taxpayer ID)
   */
  isValidCPF: (cpf) => {
    const cleanCPF = cpf.replace(/\D/g, '');
    if (cleanCPF.length !== 11 || /^(\d)\1{10}$/.test(cleanCPF)) return false;

    const digits = cleanCPF.split('').map(Number);
    const calculateCheckDigit = (factor) => {
      let sum = 0;
      for (let i = 0; i < factor - 1; i++) {
        sum += digits[i] * (factor - i);
      }
      const remainder = (sum * 10) % 11;
      return remainder >= 10 ? 0 : remainder;
    };

    return calculateCheckDigit(10) === digits[9] && calculateCheckDigit(11) === digits[10];
  },

  /**
   * Validates a Brazilian CNPJ (Corporate Taxpayer ID)
   * Compatible with the legacy numeric format and the new alphanumeric format
   * (effective July 2026): the 12 base characters may be letters or digits,
   * while the 2 check digits remain numeric.
   * See: https://www.gov.br/receitafederal (Nota Técnica CNPJ Alfanumérico)
   */
  isValidCNPJ: (cnpj) => {
    if (!cnpj) return false;

    // Strip formatting (dots, slash, hyphen), keep alphanumerics, normalize case.
    const cleanCNPJ = cnpj.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

    // 12 alphanumeric base chars + 2 numeric check digits, and not a single
    // repeated character (e.g. AAAAAAAAAAAAAA / 00000000000000).
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cleanCNPJ) || /^(.)\1{13}$/.test(cleanCNPJ)) {
      return false;
    }

    // Numeric value per the official spec: ASCII code minus 48.
    // '0'-'9' map to 0-9; 'A'-'Z' map to 17-42.
    const charValue = (char) => char.charCodeAt(0) - 48;

    const calculateCheckDigit = (length) => {
      let factor = length - 7;
      let sum = 0;

      for (let i = 0; i < length; i++) {
        sum += charValue(cleanCNPJ[i]) * factor--;
        if (factor < 2) factor = 9;
      }

      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstDigit = calculateCheckDigit(12);
    const secondDigit = calculateCheckDigit(13);

    return firstDigit === Number(cleanCNPJ[12]) && secondDigit === Number(cleanCNPJ[13]);
  },

  isValidPassport: (value) => {
    return /^[A-Za-z0-9]{5,20}$/.test(value);
  },

  isValidBrazilianPhone : (phone) => {
    if (!phone) return false;

    const digits = phone.replace(/\D/g, '');

    // DDD (2) + fixo (8) ou celular (9)
    if (digits.length === 10) {
      return /^[1-9]{2}[2-5]\d{7}$/.test(digits);
    }

    if (digits.length === 11) {
      return /^[1-9]{2}9\d{8}$/.test(digits);
    }

    return false;
  },

  isValidEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

};

export default ValidationHelper;